import { render, staticRenderFns } from "./ModalRequestorCompany.vue?vue&type=template&id=852eb202&"
import script from "./ModalRequestorCompany.vue?vue&type=script&lang=js&"
export * from "./ModalRequestorCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports